<h2>Información legal</h2>

<ion-list>
  <ion-item
    href="https://okcargo.com/condiciones-para-el-transportista/"
    target="_blank"
    button
  >
    <ion-label>Condiciones para el transportista</ion-label>
  </ion-item>
  <ion-item
    href="https://okcargo.com/politica-de-privacidad/"
    target="_blank"
    button
  >
    <ion-label>Política de privacidad</ion-label>
  </ion-item>
  <ion-item
    href="https://okcargo.com/condiciones-para-el-transportista/"
    target="_blank"
    button
  >
    <ion-label>Licencias de uso</ion-label>
  </ion-item>
  <ion-item class="fs-xs">
    <ion-label color="medium">
      @if (appVersionInfo(); as info) {
        {{ 'help.app_version' | translate }} {{ info.version }}-{{ info.build }}
      }
    </ion-label>
  </ion-item>
</ion-list>
